import { getScreenHeaderBackgroundUrl } from '../components/atomic/layout/screen_header/screenHeaderAssets';
import decorLoadingImg from './decor_loading.png';
import decorLoading2Img from './decor_loading_2.png';
import headerTextImg from './header_text.png';
import iconImg from './icon.png';
import progressBarIconFinishImg from './progress_bar_icon_finish.png';

export function getLoadingScreenAssetUrls(): string[] {
  return [
    decorLoadingImg,
    decorLoading2Img,
    headerTextImg,
    iconImg,
    progressBarIconFinishImg,
    getScreenHeaderBackgroundUrl(),
  ];
}
